import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LogLevel } from '../models';


type Level = 'debug' | 'info' | 'warn' | 'error';

const LEVEL_STYLES: Record<Level, string> = {
  debug: 'color:#9E9E9E',
  info:  'color:#2196F3;font-weight:bold',
  warn:  'color:#FF9800;font-weight:bold',
  error: 'color:#F44336;font-weight:bold',
};

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly minLevel = environment.logLevel;

  readonly debug = this.bind('debug');
  readonly info  = this.bind('info');
  readonly warn  = this.bind('warn');
  readonly error = this.bind('error');

  private bind(level: Level): (message: string, ...args: unknown[]) => void {
    if (LogLevel[level] < this.minLevel) return () => {};

    if (environment.production) {
      const label = level.toUpperCase().padEnd(5);
      return Function.prototype.bind.call(console[level], console, label) as
        (message: string, ...args: unknown[]) => void;
    }

    const style = LEVEL_STYLES[level];
    const label = `%c${level.toUpperCase().padEnd(5)} %c`;
    return Function.prototype.bind.call(console[level], console, label, style, 'color:inherit') as
      (message: string, ...args: unknown[]) => void;
  }
}
